import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@repo/lib-design-system/primitives/select.component';
import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

import { AVAILABLE_LOCALES, DEFAULT_LOCALE_CODE } from '@/i18n/available-locales';

function SelectLanguage(): ReactElement {
  const { i18n } = useTranslation();

  const currentLocale =
    AVAILABLE_LOCALES.find((locale) => locale.code === i18n.language) ??
    AVAILABLE_LOCALES.find((locale) => locale.code === DEFAULT_LOCALE_CODE) ??
    AVAILABLE_LOCALES[0];

  return (
    <Select value={currentLocale.code} onValueChange={(code) => void i18n.changeLanguage(code)}>
      <SelectTrigger
        aria-label={currentLocale.name}
        className={cn(
          'h-8 w-auto gap-1.5 border-0 bg-transparent p-1.5',
          'hover:bg-grey-100',
          'focus:ring-0 focus:ring-offset-0',
          'focus-visible:ring-2 focus-visible:ring-brand-purple',
          'dark:text-white dark:hover:bg-white/10'
        )}
      >
        <img alt="" className="h-5 w-auto rounded" src={currentLocale.flag} />
      </SelectTrigger>
      <SelectContent align="end" className="max-h-80">
        {AVAILABLE_LOCALES.map((locale) => (
          <SelectItem key={locale.code} indicatorSide="right" value={locale.code}>
            <span className="flex items-center gap-2 text-base">
              <img alt="" className="h-5 w-auto rounded" src={locale.flag} />
              {locale.name}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default SelectLanguage;
